<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber v-if="localValue.id" label="Código" placeholder="Insira Código" v-model="localValue.id" :disabled="readMode" />
      <Select :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" :disabled="localValue.id" />
      <InputZoom
        required
        clearable
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse"
        database="warehouse"
        item-value="id"
        item-text="name"
        v-model:complete-object="originWarehouseObject"
        :filter="originWarehouseFilter"
        placeholder="Selecione o depósito" />

      <InputZoom
        clearable
        required
        v-model="localValue.idSupplier"
        label="Fornecedor"
        :error="localErrors.idSupplier || localErrors.sameWarehouse"
        database="supplier"
        item-text="name"
        item-value="id"
        placeholder="Selecione o Fornecedor" />
      <InputDateTime v-model="localValue.date" label="Data" required :error="localErrors.date" placeholder="Selecione a data" disabled />
      <InputZoom
        v-model="localValue.idUser"
        clearable
        label="Responsável"
        :error="localErrors.idUser"
        database="user"
        item-text="name"
        item-value="id"
        required
        placeholder="Selecione o responsável" />
      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
  <Accordion title="Documento">
    <Grid cols-2 gap-5>
      <InputFile
        label="Arquivo"
        v-model="localValue.documentFile"
        :error="localErrors.documentFile"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
        placeholder="Selecione o arquivo" />
    </Grid>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const originWarehouseFilter = [{ column: 'type', operator: '=', value: 'physic' }]

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const originWarehouseObject = ref(null)
const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!originWarehouseObject.value || !originWarehouseObject.value.type) {
    return allTypes
  }

  const warehouseType = originWarehouseObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

watch(originWarehouseObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})
// Módulo para Corrigir tipos

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
// Computeds

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)
watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

onMounted(() => {
  // localValue.date = moment()
  localValue.idUser = user.value.id
})
</script>
